import { Box, Container } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { StyleProps } from '@chakra-ui/react';
import { ArrowButton } from '@hover/shared-components';
import { HeaderDescription } from '../common';

const wrapperStyles: StyleProps = {
  bg: 'brandGreen.100',
  py: '73px',
  mt: 1000,
  position: 'relative',
  w: '100%',
};
const contentContainerStyles: StyleProps = {
  maxW: '6xl',
  overflow: 'hidden',
  display: 'flex',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

const ProtectSection = () => (
  <Box {...wrapperStyles}>
    <Container {...contentContainerStyles}>
      <Box
        style={{
          position: 'absolute',
          margin: 'auto',
          left: 0,
          right: 0,
          top: '-53px',
          textAlign: 'center',
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <StaticImage
          aria-hidden
          placeholder="blurred"
          src="../../assets/images/protect_vector.png"
          alt="protect vector"
        />
      </Box>
      <HeaderDescription
        heading="Privacy matters"
        body="Homeowners control access to their personal data at all times."
        headingProps={{
          size: { base: 600, tablet: 700, desktop: 800 },
          color: 'brandGreen.500',
          fontWeight: { base: 600, desktop: 700 },
        }}
        bodyProps={{
          maxW: '3xl',
          paddingBottom: 700,
        }}
      />
      <ArrowButton
        colorScheme="primary"
        variant="outline"
        mb={400}
        as="a"
        target="_blank"
        href="/privacy/"
        w={{ base: '323px', tablet: 'auto' }}
      >
        See our Privacy Policy
      </ArrowButton>
    </Container>
  </Box>
);

export default ProtectSection;
